import {TrainingPlanProvider as TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider} from '../ui/TrainingPlanSelectorWithInitialDataPresenter';
import {TrainingPlanProvider as TrainingPlanSearchModalPresenterTrainingPlanProvider} from '../ui/TrainingPlanSearchModal/TrainingPlanSearchModalPresenter';
import {TrainingPlan} from '../models/TrainingPlan';

export class DefaultTrainingPlanProvider
    implements
        TrainingPlanSelectorWithInitialDataPresenterTrainingPlanProvider,
        TrainingPlanSearchModalPresenterTrainingPlanProvider
{
    public async get(): Promise<TrainingPlan[]> {
        const response = await fetch('/training/me/plans.json');

        return await response.json();
    }
}
